<template>
	<div class="pay">
		<div v-html="form">
		
		</div>
			1sjiadjda
	</div>
</template>

<script>
	import axios from 'axios'
	export default{
		data(){
			return{
				form:''
			}
		},
		mounted(){
			    var self=this
		   		var postData=this.$route.params

		   		if(postData.signCodeList.length>0){
		   			axios.post('/marlin/sign/data/pay/sign/alipay',postData)
		   			.then(function(res){
		   				self.form=res.data
		   				console.log(self.form)
		   			})
		   			.catch(function(err){
		   				
		   			})
		   		}else{
		   			self.$message({
		   				message:'请至少选择一个报名人员！',
		   				type:'warning'
		   			})
		   		}
		}
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/pages/pay.vue